import img1 from '../components/assets/images/1.jpg';
import img2 from '../components/assets/images/2.jpg';
import img3 from '../components/assets/images/3.jpg';

export const ITEMS = [
    {
      src: img1,
      key:1,
      altText: "Slide 1",
      caption: "FEATURED PRODUCT",
      header: "SHOP INDUSTRIAL INSTRUMENTS & SUPPLIES."
    },
    {
      src: img2,
      key:2,
      altText: "Slide 2",
      caption: "OUR EXPERT",
      header: "SERVICES AND SUPPLY INDUSTRIAL PRODUCTS FOR OIL & GAS", 
    },
    {
      src: img3,
      key:3,
      altText: "Slide 3",
      caption: "CONTACT US",
      header: "THROUGH OUR NETWORK. A MILLION PLUS PRODUCTS IN THE PALM OF YOUR HAND.",  
    }
  ];